<template>
  <v-container class="pa-0">
    <!-- Loader -->
    <v-skeleton-loader v-if="isLoading" type="table"></v-skeleton-loader>

    <!-- Data -->
    <v-table density="compact" v-if="!isLoading && demandes.length > 0" class="modern-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left"></th>
            <th class="text-left">N° Référence</th>
            <th class="text-left">Date d'enregistrement</th>
            <th class="text-left">Numéro carte</th>
            <th class="text-left">Prénom</th>
            <th class="text-left">Nom</th>
            <th class="text-left">Diplome obtenu</th>
            <th class="text-left">Année d'obtention</th>
            <th class="text-left">Établissement</th>
            <th class="text-left">Contact(s)</th>
            <th class="text-left">Statut</th>
            <th class="text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in demandes" :key="item.id">
            <tr :style="{ cursor: 'pointer' }" @dblclick="gotoInfos(item.id)">
              <td>
                <v-btn icon size="x-small" theme="dark" elevation="0" color="#2563eb" @click="toggleItemSupInfo(item.id)">
                  <v-icon>{{ alumni2show === item.id ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
                </v-btn>
              </td>
              <td>
                {{ item.reference_demande || 'Non renseigner' }}
              </td>
              <td>
                {{ $littleDateFormat(item.created_at) }}
              </td>
              <td>{{ item.num_carte }}</td>
              <td style="padding-right: 0px; word-wrap: break-word">
                {{ item.prenom }}
              </td>
              <td>{{ item.nom }}</td>
              <td>{{ item.dernier_diplome_obtenu }}</td>
              <td>
                {{ item.annee_obtention }}
              </td>
              <td>
                {{ getEtablissementSigle(item) }}
              </td>
              <td>
                <p v-if="item.email" class="mb-0">{{ item.email }}</p>
                <p v-if="item.telephone_1" class="mb-0">{{ item.telephone_1 }}</p>
              </td>
              <td>
                <v-chip theme="dark" :color="$colorDemandeIndiv(item.step)">
                  <v-icon start>{{ $iconDemandeIndiv(item.step) }}</v-icon>
                  {{ $statutDemandeIndiv(item.step) }}
                </v-chip>
              </td>
              <td>
                <v-btn icon color="#2563eb" :to="{
                  name: 'DemandeIndivShow',
                  params: { id: item.id }
                }">
                  <!-- <span class="font-weight-bold text-capitalize mr-2">Plus d'info</span> -->
                  <v-icon>mdi-eye-arrow-right</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-show="item.id === alumni2show">
              <td colspan="9">
                <div class="mx-auto" style="width: fit-content;">
                  <p class="text-body-2 font-weight-bold  text-center text-decoration-underline mb-0">Etablissement(s)
                    fréquenté(s) :</p>
                  <p>
                    <span v-for="(fac, index) of getFacultes(item)" :key="fac.id">
                      - {{ fac.nom }}
                      <br v-if="index < getFacultes(item).length - 1" />
                    </span>
                  </p>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-table>

    <!-- Pagination -->
    <v-pagination class="mt-5" v-if="!isLoading && pagination.total_page > 1" v-model="pagination.page"
      :length="pagination.total_page" :total-visible="10" @update:model-value="fetchIndevDemandes()"></v-pagination>

    <!-- Empty Data -->
    <empty-data v-if="!isLoading && !demandes.length" text="Aucune demande" />
  </v-container>
</template>

<script lang="js">
import { getIndivDemandes } from '../../functions/request_utils/getIndivDemandes'
import EmptyData from '../shared/EmptyData.vue'
export default {
  name: 'DemandeIndivIndex',
  components: { EmptyData },
  props: {
    pattern: { type: String, default: () => '' },
    isLoading: { type: Boolean, required: true },
    fetch: { type: Boolean, required: true }
  },
  data: () => ({
    demandes: [],
    pagination: {
      page: 1,
      total_page: 1
    },
    alumni2show: ''
  }),
  created() {
    this.fetchIndevDemandes()
  },
  methods: {
    async fetchIndevDemandes() {
      this.loadOn()
      try {
        const res = await getIndivDemandes(this.pattern, this.pagination)
        const data = Array.isArray(res?.data) ? res.data : [];

        this.demandes = data;
        this.pagination.total_page = Number(res?.last_page || 1);
      } catch (err) {
        this.demandes = [];
        this.pagination.total_page = 1;
        this.$swal.fire({ title: 'Erreur', text: err?.message || 'Problème avec les données récupérées', icon: 'error' })
      } finally {
        this.$emit('disableFetch')
        this.loadOff()
      }
    },

    toggleItemSupInfo(id) {
      if (this.alumni2show === id) {
        this.alumni2show = ''
      } else {
        this.alumni2show = id
      }
    },

    loadOn() {
      this.$emit('handleLoading', true)
    },

    loadOff() {
      this.$emit('handleLoading', false)
    },

    gotoInfos(id) {
      this.$router.push({
        name: 'DemandeIndivShow',
        params: { id: id }
      })
    },

    getEtablissementSigle(item) {
      return item && item.etab_diplome && item.etab_diplome.sigle
        ? item.etab_diplome.sigle
        : 'Non renseigner'
    },

    getFacultes(item) {
      return item && Array.isArray(item.faculte_frequente)
        ? item.faculte_frequente
        : []
    }
  },
  watch: {
    fetch(newV, old) {
      if (newV) {
        this.fetchIndevDemandes()
      }
    }
  }
}
</script>

<style scoped>
.modern-table {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}
.modern-table :deep(thead tr) {
  background: #f8fafc;
}
.modern-table :deep(th) {
  color: #475569 !important;
  font-size: 0.76rem !important;
  font-weight: 800 !important;
  letter-spacing: 0;
  text-transform: uppercase;
  white-space: nowrap;
}
.modern-table :deep(tbody tr:hover) {
  background: #f8fafc;
}
.modern-table :deep(td) {
  color: #1f2937;
  font-size: 0.88rem;
}
</style>
